import React from "react";
import {
  Card,
  Button,
  Input,
  Icon,
  Popup
} from "semantic-ui-react";
import _ from 'lodash'
import { debounce } from "lodash";
import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import LibraryCard from './../../drive/cards/LibraryCard';
import ArrangementPane from './../Practice/ArrangementPane';
import NoPlaybookPage from './../../DesignerPane/NoPlaybookPage';
import CreateNewPlaybookModal from '../../drive/modals/CreatePlaybookModal';
import LoadingComponent from '../../../../common/LoadingComponent';
import PlaybookBreadCrumbs from '../../drive/cards/BreadCrumbs'
import GroupedLibraryCard from '../../drive/cards/GroupedLibraryCard';
import GroupIcon from '../../../../layout/header/Toolbar/Component/GroupIcon'
import capitalizeWord from '../../../../../helpers/capitalizeWord'
import FilterByStatus from "../../../../layout/header/Toolbar/Component/FilterByStatus";
import GeneratingPlaybookDetailsModal from "../../drive/modals/GeneratingPlaybookDetailsModal";
import UITour from "../../../../common/UITour";

class LibraryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNewPlaybookModal: false,
      order: 1,
      open: false,
      searchLoad: false,
      loading: true,
      pracLib: []
    }
    this.gotoCreateNewPractice = this.gotoCreateNewPractice.bind(this);
    this.displayNewPlaybookModal = this.displayNewPlaybookModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount = async () => {
    if(this.props.selectedWorkspaceState){
      await dispatch.app.setSelectedOrganisationData(this.props.selectedWorkspaceState)
      await dispatch.app.setSelectedWorkspaceState(null)
    }
    let param = this.props.match.params
    let scope;
    if (param.status === "knowledgeBank" || param.status === "knowledgeBanks") {  // KLM-8964
      scope = "Private"
    } else if (param.status === "publicKnowledgeBank") {
      scope = "Public"
    } else {
      scope = null
    }
    dispatch.lifeCycle.setPlaybookSearchQuery("");
    dispatch.app.setRouteParams(param)
    dispatch.lifeCycle.activePage(null);
    dispatch.lifeCycle.displaySecondMenu(null)
    // dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.selectedAccount._id });
    dispatch.lifeCycle.getAllListAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role })
    if (!param.status) {
      dispatch.lifeCycle.setSelectedTreeId(1);
      dispatch.lifeCycle.setCreatePracticeCard(true);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
     // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
    }
    else if (param.subCategory) {
      dispatch.lifeCycle.setSelectedTreeId(param.subCategory);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
     // dispatch.lifeCycle.getPacksBySubCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, category: param.category, subCategory: param.subCategory, user: this.props.user, role: this.props.selectedOrganisation.role });
    }
    else if (param.category) {
      dispatch.lifeCycle.setSelectedTreeId(param.category);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
    //  dispatch.lifeCycle.getPacksByCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, category: param.category, user: this.props.user, role: this.props.selectedOrganisation.role });
    }
    else if (param.baseCategory) {
      dispatch.lifeCycle.setSelectedTreeId(param.baseCategory);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
     // dispatch.lifeCycle.getPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, user: this.props.user, role: this.props.selectedOrganisation.role }); // KLM-8964
    }
    else if (param.status.trim() === 'playbookLibrary') {
      dispatch.lifeCycle.setSelectedTreeId(1);
      dispatch.lifeCycle.setCreatePracticeCard(true);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
     // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
    }
    else if (param.status.trim() === 'knowledgeBank') {
      dispatch.lifeCycle.setCreatePracticeCard(false);
      dispatch.lifeCycle.setSelectedTreeId(11);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
    // dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, scope: scope, role: this.props.selectedOrganisation.role }); // KLM-8964
    }
    else if (param.status.trim() === 'knowledgeBanks') {
      dispatch.lifeCycle.setSelectedTreeId(11);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
     // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role }); // KLM-8964
      // dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, scope: scope, role: this.props.selectedOrganisation.role });
    }
    else if (param.status.trim() === 'underReview') {
      dispatch.lifeCycle.setSelectedTreeId(3);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["1"])
     // dispatch.lifeCycle.getUnderReviewPacks({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
    }
    else if (param.status.trim() === 'Generating') {
      dispatch.lifeCycle.setSelectedTreeId(9);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["-1"])
     // dispatch.lifeCycle.getUnderReviewPacks({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
    }
    else if (param.status.trim() === 'inReview') {
      dispatch.lifeCycle.setSelectedTreeId(5);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["1"])
     // dispatch.lifeCycle.getPacksInReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
    }
    else if (param.status.trim() === 'forReview') {
      dispatch.lifeCycle.setSelectedTreeId(4);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["1"])
     // dispatch.lifeCycle.getPacksForReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
    }
    else if (param.status.trim() === "In Design") {
      dispatch.lifeCycle.setSelectedTreeId(2);
      dispatch.lifeCycle.setCreatePracticeCard(true);
     await dispatch.lifeCycle.setFilterByStatus(["0"])
    //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 0, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
    }
    else if (param.status.trim() === "Approved") {
      dispatch.lifeCycle.setSelectedTreeId(6);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["2"])
    //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 2, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
    }
    else if (param.status.trim() === "Published") {
      dispatch.lifeCycle.setSelectedTreeId(7);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["4"])
    //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 4, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
    }
    // Below changes for KLM-8982
    else if (param.status.trim() === "Inactive") {
      dispatch.lifeCycle.setSelectedTreeId(8);
      dispatch.lifeCycle.setCreatePracticeCard(false);
     await dispatch.lifeCycle.setFilterByStatus(["5"])
    //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 5, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
    }
    const payload={ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role,scope:scope }
    const {params} = this.props.match
    if(params && params.baseCategory){
      payload.baseCategory=params.baseCategory
    }
    if(params && params.category){
      payload.category = params.category
    }
    if(params && params.subCategory){
      payload.subCategory = params.subCategory
    }
    if(params.status && params.status.trim() === 'knowledgeBank') {
      payload.isKnowledgeBank = true;
    }
    dispatch.lifeCycle.getPacksByStatusArray(payload)
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.createPack.showDuplicateIcon(false);
    this.setState({loading:false});
  }
  async componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.status && nextProps.match.params.status !== 'knowledgeBank') {
      //dispatch.lifeCycle.isSortingFlag(null)
      if (!_.isEqual(this.props.routeParams, nextProps.match.params)) {
        dispatch.app.setRouteParams(nextProps.match.params)
      }
    }
    if((this.props.match.params.workspaceId !== nextProps.match.params.workspaceId)){
      let param = this.props.match.params
      let scope;
      if (param.status === "knowledgeBank" || param.status === "knowledgeBanks") {  // KLM-8964
        scope = "Private"
      } else if (param.status === "publicKnowledgeBank") {
        scope = "Public"
      } else {
        scope = null
      }
      dispatch.lifeCycle.setPlaybookSearchQuery("");
      dispatch.app.setRouteParams(param)
      dispatch.lifeCycle.activePage(null);
      dispatch.lifeCycle.displaySecondMenu(null)
      // dispatch.lifeCycle.showResourecePane(null);
      dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.selectedAccount._id });
      dispatch.lifeCycle.getAllListAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role })
      if (!param.status) {
        dispatch.lifeCycle.setSelectedTreeId(1);
        dispatch.lifeCycle.setCreatePracticeCard(true);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
      }
      else if (param.subCategory) {
        dispatch.lifeCycle.setSelectedTreeId(param.subCategory);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      // dispatch.lifeCycle.getPacksBySubCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, category: param.category, subCategory: param.subCategory, user: this.props.user, role: this.props.selectedOrganisation.role });
      }
      else if (param.category) {
        dispatch.lifeCycle.setSelectedTreeId(param.category);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      //  dispatch.lifeCycle.getPacksByCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, category: param.category, user: this.props.user, role: this.props.selectedOrganisation.role });
      }
      else if (param.baseCategory) {
        dispatch.lifeCycle.setSelectedTreeId(param.baseCategory);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      // dispatch.lifeCycle.getPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, user: this.props.user, role: this.props.selectedOrganisation.role }); // KLM-8964
      }
      else if (param.status.trim() === 'playbookLibrary') {
        dispatch.lifeCycle.setSelectedTreeId(1);
        dispatch.lifeCycle.setCreatePracticeCard(true);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
      }
      else if (param.status.trim() === 'knowledgeBank') {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setSelectedTreeId(11);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
      // dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, scope: scope, role: this.props.selectedOrganisation.role }); // KLM-8964
      }
      else if (param.status.trim() === 'knowledgeBanks') {
        dispatch.lifeCycle.setSelectedTreeId(11);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
      // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role }); // KLM-8964
        // dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, scope: scope, role: this.props.selectedOrganisation.role });
      }
      else if (param.status.trim() === 'underReview') {
        dispatch.lifeCycle.setSelectedTreeId(3);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["1"])
      // dispatch.lifeCycle.getUnderReviewPacks({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
      }
      else if (param.status.trim() === 'Generating') {
        dispatch.lifeCycle.setSelectedTreeId(9);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["-1"])
      // dispatch.lifeCycle.getUnderReviewPacks({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
      }
      else if (param.status.trim() === 'inReview') {
        dispatch.lifeCycle.setSelectedTreeId(5);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["1"])
      // dispatch.lifeCycle.getPacksInReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
      }
      else if (param.status.trim() === 'forReview') {
        dispatch.lifeCycle.setSelectedTreeId(4);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["1"])
      // dispatch.lifeCycle.getPacksForReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
      }
      else if (param.status.trim() === "In Design") {
        dispatch.lifeCycle.setSelectedTreeId(2);
        dispatch.lifeCycle.setCreatePracticeCard(true);
      await dispatch.lifeCycle.setFilterByStatus(["0"])
      //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 0, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
      }
      else if (param.status.trim() === "Approved") {
        dispatch.lifeCycle.setSelectedTreeId(6);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["2"])
      //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 2, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
      }
      else if (param.status.trim() === "Published") {
        dispatch.lifeCycle.setSelectedTreeId(7);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["4"])
      //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 4, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
      }
      // Below changes for KLM-8982
      else if (param.status.trim() === "Inactive") {
        dispatch.lifeCycle.setSelectedTreeId(8);
        dispatch.lifeCycle.setCreatePracticeCard(false);
      await dispatch.lifeCycle.setFilterByStatus(["5"])
      //  dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 5, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
      }
      const payload={ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role,scope:scope }
      const {params} = this.props.match
      if(params && params.baseCategory){
          payload.baseCategory=params.baseCategory
      }
      if(params && params.category){
          payload.category = params.category
      }
      if(params && params.subCategory){
          payload.subCategory = params.subCategory
      }
      if(params.status && params.status.trim() === 'knowledgeBank') {
        payload.isKnowledgeBank = true;
      }
      dispatch.lifeCycle.getPacksByStatusArray(payload)
      dispatch.app.setCollapsedResourcePaneIndexTemp(null)
      dispatch.createPack.showDuplicateIcon(false);
      this.setState({loading:false});
    }
  }
  // Below changes made for KLM-9004 & KLM-9005
  componentDidUpdate(prevProps) {
    if(this.props.PracticeLibrarys !== prevProps.PracticeLibrarys) {
      this.setState({pracLib: this.props.PracticeLibrarys})
    }
  }
  gotoCreateNewPractice(e) {
    e.preventDefault();
    const { history } = this.props;
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/page/create`,
    });
    dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.setArrangementPaneFlag(false)
    dispatch.lifeCycle.modalEditOpen(false);
  }

  displayNewPlaybookModal() {
    this.setState({ showNewPlaybookModal: true });
  }

  closeModal() {
    this.setState({ showNewPlaybookModal: false });
  }



  groupData = (data) => {
    if (data.value === "reset") {
      dispatch.lifeCycle.isSortingFlag({ key: "createdAt", order: 1, text: "CreatedAt" });
    } else {

      dispatch.lifeCycle.isSortingFlag({ key: data.value, order: data.order });
    }
    this.setState({ order: 1 })
  }

  sortByStatus = () => {


    let query = {
      organizationId: this.props.selectedOrganisation.id,
      user: this.props.user,
      role: this.props.selectedOrganisation.role,
      accountUserId: this.props.user._id
    }

    if (this.props.sortingFlag) {
      // query.$sort = { [this.props.sortingFlag.value]: this.state.order };
      // query.sortBy = { key: this.props.sortingFlag.key, order: this.state.order }
      // dispatch.lifeCycle.getPacksAsync(query);
      dispatch.lifeCycle.isSortingFlag({ key: this.props.sortingFlag.key, order: this.state.order });

    }
    else {
      query.$sort = { 'createdAt': this.state.order }
      dispatch.lifeCycle.isSortingFlag(null);
      dispatch.lifeCycle.getPacksAsync(query);
    }
    this.setState({ order: this.state.order === 1 ? -1 : 1 });

  }

  // Below change for KLM-9057

  handleKeyPress = (e) => {
    if(e.key === "Enter") {
      e.preventDefault()
    }
    if(this.state.searchLoad) {
      e.preventDefault()
    }
  }

  // Below changes for KLM-9064
  handleKeyDown = (e) => {
    if(e.key === "Backspace" && this.state.searchLoad){
      e.preventDefault()
    }
  }

  // Below changes made for KLM-8989

  onChangeHandel = (e) => {
    dispatch.lifeCycle.setPlaybookSearchQuery(e.target.value);
    if (e.target.value.length === 0) {
        this.setState({ open: true })
    } else {
        this.setState({ open: false })
    }
    this.searchEvent(e.target.value)
    // this.setState({searchLoad: true})
  }

  searchEvent = debounce(async (text) => {
    let param = this.props.match.params
    let scope;
    if (param.status === "knowledgeBank") {
      scope = "Private"
    } else if (param.status === "publicKnowledgeBank") {
      scope = "Public"
    } else {
      scope = null
    }
    if(text === "" || text === null) {
      if (!param.status) {
        // dispatch.lifeCycle.setCreatePracticeCard(true);
        // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role }).then(() => {
        //   this.setState({searchLoad: false})
        // })
        let filteredPracLib = this.props.PracticeLibrarys.filter((f) => {
          return f.name.toLowerCase().includes(text.toLowerCase())
        })
        this.setState({
          pracLib: filteredPracLib,
          searchLoad: false
        })
      }
      else if(param.status !== "" && text=== "" ){
        let filteredPracLib = this.props.PracticeLibrarys.filter((f) => {
          return f.name.toLowerCase().includes(text.toLowerCase())
        })
        this.setState({
          pracLib: filteredPracLib,
          searchLoad: false
        })
      }
      else if (param.subCategory) {
        dispatch.lifeCycle.getPacksBySubCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, category: param.category, subCategory: param.subCategory, user: this.props.user, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.category) {
        dispatch.lifeCycle.getPacksByCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, category: param.category, user: this.props.user, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.baseCategory) {
        dispatch.lifeCycle.getPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, baseCategory: param.baseCategory, user: this.props.user, role: this.props.selectedOrganisation.role }).then(() => {  // KLM-8964
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === 'playbookLibrary') {
        dispatch.lifeCycle.setCreatePracticeCard(true);
        dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === 'knowledgeBank') {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        // dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
        dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, scope: scope, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        }); // KLM-8964

      }
      else if (param.status.trim() === 'knowledgeBanks') {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        // dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, scope: scope, role: this.props.selectedOrganisation.role });
        dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        }); // KLM-8964
      }
      else if (param.status.trim() === 'underReview') {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["1"])
        dispatch.lifeCycle.getUnderReviewPacks({ organizationId: this.props.selectedOrganisation.id, user: this.props.user }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === 'inReview') {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["1"])
        dispatch.lifeCycle.getPacksInReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === 'forReview') {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["1"])
        dispatch.lifeCycle.getPacksForReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === "In Design") {
        dispatch.lifeCycle.setCreatePracticeCard(true);
        dispatch.lifeCycle.setFilterByStatus(["0"])
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 0, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === "Approved") {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["2"])
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 2, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === "Published") {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["4"])
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 4, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      // Below changes for KLM-8982
      else if (param.status.trim() === "Inactive") {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["5"])
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 5, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
      else if (param.status.trim() === "Generating") {
        dispatch.lifeCycle.setCreatePracticeCard(false);
        dispatch.lifeCycle.setFilterByStatus(["-1"])
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 5, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }).then(() => {
          this.setState({searchLoad: false})
        })
      }
    }
    else {
      let filteredPracLib = this.props.PracticeLibrarys.filter((f) => {
        return f.name.toLowerCase().includes(text.toLowerCase())
      })
      this.setState({
        pracLib: filteredPracLib,
        searchLoad: false
      })
    }
  }, 1000);

  onFocus = () => {
    if (this.props.playbookSearchQuery.length === 0) {
        this.setState({ open: true })
    }
  }

  onBlur = () => {
    this.setState({ open: false })
  }

  clearInput = (e, value) => {
    dispatch.lifeCycle.setPlaybookSearchQuery("");
    this.searchEvent("")
  }

  render() {
    let height = 500;

    let loaderComp = null
    // setTimeout(() => this.setState({loading: false}), 3000)

    if (this.props.loadingPacks || this.state.loading) {
      loaderComp = <LoadingComponent active={this.props.loadingPacks || this.state.loading} message="Loading Playbooks" />
    }
    else if (this.state.searchLoad) {
      loaderComp = <LoadingComponent active={this.state.searchLoad} message="Searching Playbooks..." />
    }
    else if (this.props.copyingPlaybook) {
      loaderComp = <LoadingComponent active={this.props.copyingPlaybook} message="Copying Playbook" />
    }
    return (
      <div
        style={{ maxHeight: isNaN(height.windowHeight) || isNaN(height.height) ? 2160 : (height.windowHeight - height.height) - 50 }}
        className={`${this.props.arrangementPaneFlag ? "containerBox" : "containerBoxFullWidth"} overflow-hide pad_20`}>
        {loaderComp}
        {/* {((localStorage.getItem('showUiTour') && localStorage.getItem('showUiTour') == 'true') && (loaderComp.props.active==false)) ? <UITour user={this.props.user}/> : ""} */}
        {(this.props.arrangementPaneFlag) ?
          <ArrangementPane {...this.props} setPage="Define" />
          : null
        }
        <div style={{ height: "30px" }}>
          <div className="float-left" style={{ width: "calc(100% - 200px)" }}>
            <PlaybookBreadCrumbs {...this.props} />
          </div>
          <Popup
            className="cursor-pointer popupStyled"
            inverted
            position="left center"
            open={this.state.open}
            hoverable={true}
            trigger={
                <form className="float-left pad_5" autoComplete="off" style={{ width: "33%" }}>
                    <Input
                        className="w_100 searchEventInput"
                        placeholder='Search by Playbook name...'
                        onChange={(e) => { this.onChangeHandel(e) }}
                        name="name"
                        value={this.props.playbookSearchQuery}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        icon={this.props.playbookSearchQuery ?
                          <Icon name="close" className="cursor-pointer" onClick={(e) => this.clearInput(e, null)} /> :
                          <Icon name="search" />
                      }
                        onKeyPress={(e)=>{this.handleKeyPress(e)}}
                        onKeyDown={(e) => {this.handleKeyDown(e)}}
                    />
                </form>
              }
            disabled
          />
            <div className="float-right" style={{ width: "400px" }}>              
              <GroupIcon
                handleSort={this.groupData}
                routeParams={this.props.routeParams}
                PracticeLibrarys={this.props.PracticeLibrarys}
                page="Playbook"
                //disabled={this.props.routeParams && (this.props.routeParams.playbookId || this.props.routeParams.status) ? true : false}
                sortingFlag={this.props.sortingFlag}
              />
              <Popup
                className="popupStyled"
                inverted
                trigger={<Button
                  icon={`sort ${this.state.order === 1 ? 'amount up' : "amount down"}`}
                  onClick={this.sortByStatus}
                  // disabled={this.props.disabled}
                  className="float-right pad_5"
                  size="mini"
                />}
                content={`Sort by ${this.props.sortingFlag && this.props.sortingFlag.key ?
                  this.props.sortingFlag.key === "scope" ? "Library" :
                    capitalizeWord(this.props.sortingFlag.key) : "Date"}`}
                position="left center"
              />
              <FilterByStatus
                routeParams={this.props.routeParams}
                PracticeLibrarys={this.props.PracticeLibrarys}
                page="Playbook"
                {...this.props}
              />
            </div>
        </div>
        <div className="clear-both">
          {this.props.sortingFlag ?
            <GroupedLibraryCard
              PracticeLibrarys={this.state.pracLib}
              clickIndex={this.props.libraryCardIndex}
              selectedPracticeLibrary={this.props.selectedPracticeLibrary}
              selectedCardLoader={this.props.selectedCardLoader}
              sortingFlag={this.props.sortingFlag}
              displayNewPlaybookModal={this.displayNewPlaybookModal}
              landingMessage={`No ${this.props.practiceLabelName} available to display.`}
              showTitle={true}
              history={this.props.history}
              routeParams={this.props.routeParams}

            />
            :
            <Card.Group className="playbookCardsList" >
              {this.state.pracLib &&
                this.state.pracLib.length ?
                this.state.pracLib.map(function (PracticeLibrary, index) {
                  return (
                    <LibraryCard
                      id={PracticeLibrary._id}
                      key={index}
                      index={index}
                      PracticeLibrary={PracticeLibrary}
                      clickIndex={this.props.libraryCardIndex}
                      selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                      selectedCardLoader={this.props.selectedCardLoader} />
                  );
                }, this) :
                <NoPlaybookPage displayNewPlaybookModal={this.displayNewPlaybookModal} landingMessage={`No ${this.props.practiceLabelName} available to display.`} showTitle={true} history={this.props.history} {...this.props.match.params} />}
            </Card.Group>
          }
        </div>

        <CreateNewPlaybookModal
          showNewPlaybookModal={this.state.showNewPlaybookModal}
          createPack={this.gotoCreateNewPractice}
          accountId={this.props.match.params.accountId}
          organizationId={this.props.match.params.workspaceId}
          closeModal={this.closeModal} {...this.props} />
          <GeneratingPlaybookDetailsModal selectedPracticeLibrary={this.props.selectedPracticeLibrary} {...this.props}/>
      </div >
    );
  }
}
export default withRouter(LibraryView);
